// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const stationDetailSchema = z.object({
  "id": z.string().uuid(),
  "product_area": z.enum(["badge_sign_in", "kiosk_pass"]),
  "station_name": z.string(),
  "location_label": z.string().optional(),
  "status": z.enum(["active", "suspended", "quarantined", "revoked"]),
  "failed_attempt_count": z.number().int(),
  "quarantined_until": z.string().datetime({ offset: true }).optional(),
  "last_seen_at": z.string().datetime({ offset: true }).optional(),
  "paired_at": z.string().datetime({ offset: true })
});

export const badgeSchema = z.object({
  "id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "tier": z.enum(["tier1", "tier2"]),
  "status": z.enum(["active", "revoked", "expired", "superseded"]),
  "issued_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }).optional()
});

export const badgesResponseSchema = z.object({
  "badges": z.array(badgeSchema)
});

export const issueBadgeRequestSchema = z.object({
  "tier": z.enum(["tier1"]),
  "expires_at": z.string().datetime({ offset: true }).nullable().optional()
});

export const issueBadgeResponseSchema = z.object({
  "badge": badgeSchema,
  "badge_nonce": z.string()
});

export const revokeBadgeRequestSchema = z.object({
  "reason": z.enum(["admin_revoked", "user_lost_badge", "expired", "superseded"])
});

export const resetPinRequestSchema = z.object({
  "reset_reason": z.enum(["user_forgot", "policy_rotation", "incident_response"])
});

export const resetPinResponseSchema = z.object({
  "temp_pin": z.string(),
  "set_at": z.string().datetime({ offset: true }),
  "must_rotate": z.literal(true)
});

export const tempQRSchema = z.object({
  "id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "status": z.enum(["active", "consumed", "expired", "revoked"]),
  "issued_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true })
});

export const tempQRsResponseSchema = z.object({
  "temp_qrs": z.array(tempQRSchema)
});

export const issueTempQRRequestSchema = z.object({
  "expires_in_minutes": z.number().int().min(0).optional()
});

export const issueTempQRResponseSchema = z.object({
  "recovery_code": z.string(),
  "expires_at": z.string().datetime({ offset: true })
});

export const revokeTempQRRequestSchema = z.object({
  "reason": z.enum(["admin_killed", "worker_recovered_otherwise"])
});
